import $ from 'jquery'
import {resetSelector} from "../../../assets/src/scripts/selector.js";
import {Core} from "../../../assets/src/scripts/core.js";

export class InteractiveMap {
  constructor($container) {
    this.map_references = $container.data('map-references')

    if (!this.map_references)
      return

    this.classes = {
      'highlight': 'highlight',
      'active': 'active',
      'hidden': 'hidden',
      'department': 'department',
      'referenceId': 'reference-id',
    }
    this.classInputTextSearch = '#filter-search'

    this.$form = $container.find('.interactive-map-filters form')
    this.$map = $container.find('.interactive-map-map svg')
    this.$mapDepartments = this.$map.find(`[data-${this.classes.department}]`)
    this.$list = $container.find('.interactive-map-list')
    this.$listDepartments = this.$list.find('.interactive-map-list-item')
    this.$listReferences = this.$list.find('.card-reference')
    this.listNoResult = $container.find('.interactive-map-list-no-result')
    this.$resetButton = $container.find('#reset-search-filters')

    //this.$resetButton = this.$form.find('#reset-search-filters')
    this.$filterSearch = this.$form.find(this.classInputTextSearch)
    this.$filterTags = this.$form.find('.archive-search-filter-tags')
    this.$buttonShowFilters = this.$form.find('.js-show-filters')

    this.$filterSearch.on('keyup', this.handleForm.bind(this))
    this.$form.on('change submit', this.handleForm.bind(this))
    this.$form.on('click', '.archive-search-filter-tags .search-tag', this.handleClickTag.bind(this))
    this.$map.on('click', `.${this.classes.highlight}`, this.handleClickMapReference.bind(this))
    this.$resetButton.on('click', this.handleResetForm.bind(this))

    if (this.$buttonShowFilters.length) {
      this.$buttonShowFilters.on('click', this.handleClickButtonShowFilters.bind(this))
    }

    this.initStyliseMap()
  }

  handleClickButtonShowFilters (e) {
    e.preventDefault()

    $(e.currentTarget).remove()
    this.$form.removeClass('reduce-filters-on-mobile')
  }

  handleClickMapReference(e) {
    let $target = $(e.currentTarget)

    if ($target.hasClass(this.classes.active)) {
      $target.removeClass(this.classes.active)
      this.$listDepartments.removeClass(this.classes.hidden)

      return
    }

    this.$mapDepartments.removeClass(this.classes.active)

    $target.addClass(this.classes.active)

    let department = $target.data('department')

    this.$listDepartments.each((i, item) => {
      let $item = $(item)
      let current_department = $item.data('department')

      if (current_department == department) {
        $item.removeClass(this.classes.hidden)
      } else {
        $item.addClass(this.classes.hidden)
      }
    })
  }

  handleClickTag(e) {
    e.preventDefault()
    let $item = $(e.currentTarget)
    let $select = this.$form.find(`select[name="${$item.data('category')}"]`)

    $select.parent().find(`.selector-option-selected[data-value="${$item.data('value')}"]`).click()

    $item.remove()
  }

  handleResetForm(e) {
    this.$filterSearch.val('')

    this.resetSelectors()
    this.resetMapAndList()
    this.updateTags()
    this.handleForm(e)
  }

  handleForm(e) {
    if (e.type === 'submit') {
      e.preventDefault()
    }

    this.formDataTemp = this.formatDataTemp()

    this.updateTags()

    if ($.isEmptyObject(this.formDataTemp)) {
      this.resetMapAndList()
      return
    }

    this.listNoResult.addClass(this.classes.hidden)
    this.resetMapAndListBlank()
    this.hideAllItemsList()
    this.hasResult = false

    Object.keys(this.map_references).forEach(this.filterMapListByDepartment.bind(this))

    if (!this.hasResult) {
      this.listNoResult.removeClass(this.classes.hidden)
    }

  }

  filterMapListByDepartment(code_department) {
    this.currentDepartment = this.map_references[code_department]
    this.isActiveCurrentDepartment = false

    this.currentDepartment.forEach(this.filterMapListByReference.bind(this))

    if (this.isActiveCurrentDepartment) {
      this.highlightMapDepartment(code_department)
      this.activeListDepartment(code_department)
    }
  }

  filterMapListByReference(reference) {
    reference.$el = this.$list.find(`[data-${this.classes.referenceId}="${reference.id}"]`)

    this.currentReference = reference
    this.isActiveCurrentReference = false

    Object.keys(this.formDataTemp).forEach(this.filterMapListByFormData.bind(this))
  }

  filterMapListByFormData(filterCategory) {
    if (this.isActiveCurrentReference) {
      return
    }

    let formData = this.formDataTemp[filterCategory]

    if (filterCategory === 'txt') {
      let textReference = this.currentReference.$el.text().toLowerCase()

      if (textReference.includes(formData)) {
        this.isActiveCurrentDepartment = true
        this.isActiveCurrentReference = true
        this.hasResult = true
        this.currentReference.$el.removeClass(this.classes.hidden)
      }
    } else {
      if (this.currentReference.hasOwnProperty(filterCategory)) {
        let categoryIdIsInReference = false
        let categoryIds = this.currentReference[filterCategory]

        formData.forEach(function (category) {
          if (typeof categoryIds === 'number') {
            if (category === categoryIds) {
              categoryIdIsInReference = true
            }
          } else if (categoryIds.includes(category)) {
            categoryIdIsInReference = true
          }
        })

        if (categoryIdIsInReference) {
          this.isActiveCurrentDepartment = true
          this.isActiveCurrentReference = true
          this.currentReference.$el.removeClass(this.classes.hidden)
          this.hasResult = true
        }
      }
    }
  }

  initStyliseMap() {
    // Fix height list
    if (Core.isBpGreaterThan('md')) {
      this.$list.height(this.$map.height())
    }
    // Highlight departments
    this.highlightMapDepartments()
  }

  highlightMapDepartments() {
    Object.keys(this.map_references).forEach(this.highlightMapDepartment.bind(this))
  }

  highlightMapDepartment(code_department) {
    this.$mapDepartments.filter(`[data-${this.classes.department}="${code_department}"]`).addClass(this.classes.highlight)
  }

  activeListDepartment(code_department) {
    this.$listDepartments.filter(`[data-${this.classes.department}="${code_department}"]`).removeClass(this.classes.hidden)
  }

  resetMapAndListBlank() {
    this.$listDepartments.removeClass(this.classes.hidden)
    this.$listReferences.removeClass(this.classes.hidden)
    this.$mapDepartments.removeClass(this.classes.active)
    this.$mapDepartments.removeClass(this.classes.highlight)
  }

  hideAllItemsList() {
    this.$listDepartments.addClass(this.classes.hidden)
    this.$listReferences.addClass(this.classes.hidden)
  }

  resetMapAndList() {
    this.listNoResult.addClass(this.classes.hidden)

    this.resetMapAndListBlank()
    this.highlightMapDepartments()
  }

  formatDataTemp() {
    let excludedNameForm = ['action', 'page_id', 'spaged', 'submit']
    let formData = this.$form.serializeArray()
    let formDataTemp = {}

    formData.forEach(function (item) {
      if (excludedNameForm.includes(item.name)) {
        return
      }

      let name = item.name.replace(/\[\]$/, '').replace('-', '_')

      if (item.name === 'txt') {
        if (item.value.length > 0) {
          formDataTemp[item.name] = item.value
        }
      } else {
        if (typeof formDataTemp[name] == "undefined") {
          formDataTemp[name] = []
        }

        formDataTemp[name].push(parseInt(item.value))
      }
    })

    return formDataTemp
  }

  updateTags() {
    this.$filterTags.html('')
    let selectArray = this.$form.find('select')

    selectArray.each((index, select) => {
      let $select = $(select)

      $select.find(':selected').each((index, option) => {
        let $option = $(option)

        if ($option.attr('value') !== '-1') {
          this.$filterTags.append(`<div class="search-tag" data-category="${$select.attr('name')}" data-value="${$option.attr('value')}"><i class="icon icon-close_1"></i>${$option.text()}</div>`)
        }
      })
    })
  }

  resetSelectors() {
    this.$form.find('.selector').each(function (index, select) {
      resetSelector($(select))
    })
  }
}
